export default {"src":"/_next/static/media/spiritoryLogo.fb770488.svg","height":474,"width":474,"blurWidth":0,"blurHeight":0};